import moment from 'moment';

import { useSelector } from 'react-redux';
import useApi from '../useApi';
import { useShowSnackbar } from '../useShowSnackbar';

export const useRegisterDsp = () => {
  const user = useSelector((state) => state.user);
  const showSnackbar = useShowSnackbar();

  const { data, loading, postData } = useApi('/BlazorApi/adupdatedsp', 'POST', null, 50000);

  const createUpdateDsp = async (dspRegData) => {
    const body = {
      ...dspRegData,
      address: dspRegData.address,
      SurfaceAddress: dspRegData.address,
      whatsApp: dspRegData.isWhatsappAsso === true ? dspRegData.contact : '',
      stateId: parseInt(dspRegData.stateId),
      businessTypeId: parseInt(dspRegData.businessTypeId),
      lastUpdatedAt: moment().utc().format(),
      lastUpdatedBy: user.userId !== '' ? user.userId : 0,
      updatedBy: user.userId !== '' ? user.userId : 0,
      createdBy: user.userId !== '' ? user.userId : 0,
      status: parseInt(dspRegData.status ?? '1'),
    };
    const res = await postData(body);
    if (!res?.status) showSnackbar(res?.message, 'error');
    return res;
  };

  return { data, loading, createUpdateDsp };
};
